// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3t666","inputWrap":"styles_inputWrap__1H6Zc","input":"styles_input__zpIL7"};